import { render, staticRenderFns } from "./WalletOutline.vue?vue&type=template&id=14869db4&"
import script from "./WalletOutline.vue?vue&type=script&lang=ts&"
export * from "./WalletOutline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports